import Vue from 'vue';
import FaqWrap from '../vue/Faq/FaqWrap.vue';

export default {
  init() {

    new Vue({
      el: "#faq-search",
      components: { FaqWrap },
    });

    // $('.question-item .question-head').on('click', function () {
    //   const item = $(this).parent();

    //   $('.question-item').not(item)
    //     .removeClass('active')
    //     .find('.question-body')
    //     .slideUp(200);

    //   item.toggleClass('active');
    //   item.find('.question-body').stop().slideToggle(200);
    // });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};